import React, { useState, useEffect, Fragment } from 'react';
import { PrimaryButton, Checkbox, IconButton, ActionButton, mergeStyleSets, } from '@fluentui/react';
import htmr from 'htmr';
import Correct from './Correct';
import Incorrect from './Incorrect';
import Explanation from './Explanation';

function MultipleSelect(props) {
    const [answers, setAnswers] = useState([]);
    
    useEffect(() => {
        props.data.answers.forEach(x => {
            x.checked = props.value && props.value.length > 0 && props.value.filter(y =>y == x.qnsAnswerId).length;
        })
        setAnswers(props.data.answers)

    }, []);

    const _onControlledCheckboxChange = i => (ev, checked) => {
        let newArr = [...answers];
        newArr[i].checked = checked
        setAnswers(newArr)
        props.setValues(newArr.filter(x => x.checked).map(x => x.qnsAnswerId))
    };


    return (
        <div className="flexcolumn displayflex flex1 prelative quiz-container">
            <div style={{ fontSize: 16 }}>
                {htmr(props.data.question)}
            </div>
            <div className="displayflex flex1 width100 " style={{ maxWidth: 600, marginTop: props.view ? 10 : 20 }}>
                <form className="default-form width100">
                    <div class="form-group width100">
                        {answers.map((answer, index) => (
                            <Checkbox label={answer.label} checked={answer.checked} onChange={_onControlledCheckboxChange(index)} />
                        ))}
                    </div>
                </form>
            </div>
            {props.showExplanation && <Explanation setShowExplanation={props.setShowExplanation} data={props.data} callback={props.callback} complete={props.complete} />}
            {props.showCorrect && <Correct />}
            {props.showInCorrect && <Incorrect />}
        </div>
    );
}

export default MultipleSelect;